import isemail from 'isemail';

export const validateEmail = (email: string): boolean => {
  return isemail.validate(email);
};
